import axios from '../../../../apis/Api'
import history, { logout } from '../../../../history'
import storage from '../../../../apis/Storage'
import { toast } from 'react-toastify'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import {
  GET_DATEWISE_SHOPS_SUMMARY_REPORT
} from '../../../../Types'
import fileSaver from 'file-saver'
import * as XLSX from 'xlsx'

export const getDateWiseShopsSummaryReport = (requestData) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .post(`api/Reports/GetDateWiseShopsSummary`, requestData)
    .then(({ data }) => {
      console.log('response from API ::', data)
      if (data && data?.response)
        dispatch({
          type: GET_DATEWISE_SHOPS_SUMMARY_REPORT,
          payload: data.response,
        })
      dispatch(hideLoading())
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data) toast.error(error.response.data.Message ? error.response.data.Message : error.response.data.message)
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}


export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/Reports/GetDateWiseShopsSummary`, requestData)
    .then(({ data }) => {
      const outputFilename = `ACTIVE_SHOPS_SUMMARY_Report_${Date.now()}`;
      const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const fileExtension = '.xlsx';

      const exportToCSV = (csvData, fileName) => {
        // Only include required columns before converting to sheet
        const filteredData = csvData.map((row) => ({
          date: row.date,
          totalShops: row.totalShops,
          status: row.status,
        }));

        // Convert filtered data to sheet
        const ws = XLSX.utils.json_to_sheet(filteredData);

        // Rename headers
        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const address = XLSX.utils.encode_col(C) + '1';
          if (!ws[address]) continue;

          const val = ws[address].v;
          ws[address].v =
            val === 'date'
              ? 'Date'
              : val === 'totalShops'
              ? 'Total Shops'
              : val === 'status'
              ? 'Pulse Status'
              : val;
        }

        const wb = {
          Sheets: { data: ws },
          SheetNames: ['data'],
        };

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const fileData = new Blob([excelBuffer], { type: fileType });
        fileSaver.saveAs(fileData, fileName + fileExtension);
      };

      exportToCSV(data?.response || [], outputFilename);
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push('/login');
          history.go('/login');
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error('Error while processing the request');
        }
      }
    });
};

